interface Stat {
  name: string;
  quantity: string;
  nameColor: string;
  quantityColor: string;
}

interface ProductInventoryStatsProps {
  productInventoryStats: Stat[];
  loading: Boolean;
}

const ProductInventoryStatsCard: React.FC<ProductInventoryStatsProps> = ({
  productInventoryStats,
  loading,
}) => {
  return (
    <li className="h-max overflow-hidden rounded-xl border border-gray-200 shadow-md">
      <div className="flex infos-center gap-x-4 border-b border-gray-900/5 bg-gray-50 px-6 py-4">
        <div className="text-xl font-medium leading-6 text-gray-900">
          Product Details
        </div>
      </div>

      <div className="overflow-hidden bg-white px-6 py-4 space-y-4">
        {productInventoryStats.map((item) => (
          <div className="flex justify-between text-xl" key={item.name}>
            <p className={`font-semibold ${item.nameColor}`}>{item.name}</p>
            <p className={`font-bold ${item.quantityColor}`}>{item.quantity}</p>
          </div>
        ))}
      </div>
    </li>
  );
};

export default ProductInventoryStatsCard;
